import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { Sizes, propTypes, defaultProps } from './LoadingIndicator.types.js';
import LoadingIndicatorAnimation from './loading-indicator-animation.json.js';
import LoadingIndicatorWhiteAnimation from './loading-indicator-white-animation.json.js';
import { Player } from '@lottiefiles/react-lottie-player';
import styles from './LoadingIndicator.module.scss.js';

var LoadingIndicator = /** @class */ (function (_super) {
    __extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingIndicator.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, size = _b.size, greyAnimation = _b.greyAnimation;
        var loadingAnimation = greyAnimation
            ? LoadingIndicatorAnimation
            : LoadingIndicatorWhiteAnimation;
        var sizeOptions = (_a = {},
            _a[Sizes.sm] = styles.LoadingIndicator___sm,
            _a[Sizes.md] = styles.LoadingIndicator___md,
            _a[Sizes.lg] = styles.LoadingIndicator___lg,
            _a[Sizes.xl] = styles.LoadingIndicator___xl,
            _a);
        return (React__default.createElement("div", { className: "\n                    " + styles.LoadingIndicator + " " + sizeOptions[size] + " \n                    " + (className || '') + "\n                " },
            React__default.createElement(Player, { autoplay: true, loop: true, src: loadingAnimation })));
    };
    LoadingIndicator.displayName = 'LoadingIndicator';
    LoadingIndicator.propTypes = propTypes;
    LoadingIndicator.defaultProps = __assign({}, defaultProps);
    return LoadingIndicator;
}(React__default.Component));

export default LoadingIndicator;
